import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { saveAuth, getSavedUser } from "../lib/globalfunction";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import Header from "../Header";
import moment from "moment";
export default function ReferList({ onLogin }) {
  const navigate = useNavigate();

  const [dataList, setDataList] = useState([]);

  const [currentScreen, setCurrentScreen] = useState("referral");
  const [referralDate, setReferralDate] = useState({});

  const getData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getpatientreferral`,
        {
          params: {
            FacilityCode: getSavedUser().FacilityCode
            // page: page + 1, // backend page starts from 1
            // limit: limit,
          },
        }
      );
      console.log("API response.data.data:", response.data.data);
      setDataList(response.data.data);
      // setTotal(response.data.total);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const showDetails = (obj) => {
    console.log("Showing details for:", obj);
    setReferralDate(obj);
    setCurrentScreen("details");
  };

  const closeReferral = (params) => {
    // setConfirmationConfig({ ...confirmationConfig, show: false });

    setCurrentScreen("referral");
  };

  return (
    <div data-theme="dark">
      <div className="fixed inset-0 w-full h-full pointer-events-none z-0 transition-colors duration-500">
        <div
          className="absolute top-[-10%] left-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-1)" }}
        ></div>
        <div
          className="absolute bottom-[-10%] right-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-2)" }}
        ></div>
      </div>

      <div
        className="relative z-10 w-full max-w-md mx-auto flex flex-col shadow-2xl transition-all duration-500 overflow-hidden"
        style={{
          height: "100dvh",
          background: "rgba(2, 6, 23, 0.8)",
          borderLeft: "1px solid var(--glass-border)",
          borderRight: "1px solid var(--glass-border)",
        }}
      >
        <div
          id="screen-home"
          className=" absolute inset-0 flex flex-col bg-transparent z-30"
        >
          <div
            id="screen-history"
            className=" absolute inset-0 flex flex-col z-40"
            style={{ backgroundColor: "var(--bg-app)" }}
          >
            <Header BackTo={"/home"} />

            {/* <div className="p-6 pt-12 glass flex justify-between items-center shrink-0 z-20">
              <div className="flex items-center gap-3">
                <button
                  onclick="showScreen('home')"
                  className="p-2 glass rounded-full hover:opacity-80 cursor-pointer"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 19l-7-7 7-7"
                    ></path>
                  </svg>
                </button>
                <h2 className="text-xl font-bold tracking-tight">History</h2>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-widest text-muted">
                  Total
                </span>
                <span className="text-sm font-mono bg-blue-600 text-white px-2 py-0.5 rounded">
                  4
                </span>
              </div>
            </div> */}

            <div className="flex-1 overflow-y-auto p-4 space-y-4 pb-12 hide-scroll">
              {currentScreen === "referral" && (
                <>
                  {dataList.map((obj, index) => (
                    <div className="glass p-4 rounded-2xl border-l-[4px] border-l-purple-500 animate-enter group relative overflow-hidden">
                      <div className="absolute right-0 top-0 w-32 h-32 bg-purple-500/5 rounded-full blur-xl group-hover:bg-purple-500/10 transition-colors"></div>
                      <div className="flex justify-between items-start mb-2 relative z-10">
                        <span className="text-xs font-mono font-medium text-purple-400">
                          {moment(obj.EntryDateTime).format("DD-MM-YYYY H:m:s")}
                        </span>
                        <div className="flex gap-2">
                          <span className="text-[10px] font-mono px-2 py-0.5 rounded bg-white/5 border border-white/10 text-muted">
                            ID: {obj.PatientId}
                          </span>
                          <span className="text-xs font-mono px-2 py-0.5 rounded border border-white/10 text-main">
                            ICD:{obj.Icd10Code}
                          </span>
                        </div>
                      </div>
                      <h3 className="text-xl font-medium tracking-wide text-main leading-tight mb-1 relative z-10">
                        {obj.ReferredToFacilityName}
                      </h3>
                      <p className="text-sm text-muted italic mb-3 relative z-10">
                        {obj.Diagnosis}
                      </p>
                      <div
                        className="flex justify-between items-end border-t pt-3 mt-2 relative z-10"
                        style={{ borderColor: "var(--glass-border)" }}
                      >
                        <div className="flex items-center gap-3 text-xs text-muted">
                          <span
                            className="px-2 py-1 rounded flex items-center gap-1"
                            style={{ background: "var(--glass-border)" }}
                          >
                            {obj.Gender}, {obj.Age} Y
                            {/* {obj.InvestigationsWithResults} */}
                          </span>
                        </div>
                        <div className="flex gap-2">
                          {/* <button
                      className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-purple-500 hover:text-white transition-all text-purple-400 cursor-pointer"
                      style={{borderColor: "var(--glass-border)"}}
                    >
                      <svg
                        className="w-3 h-3 ml-0.5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </button> */}
                          <button
                            className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-purple-500 hover:text-white transition-all text-purple-400 cursor-pointer"
                            style={{ borderColor: "var(--glass-border)" }}
                            onClick={() => showDetails(obj)}
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              ></path>
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}

              {/* Details Screen */}
              {currentScreen === "details" && (
                <div
                  className="absolute inset-0 flex flex-col z-50"
                  style={{ backgroundColor: "var(--bg-app)" }}
                >
                  <div className="p-6 pt-10 flex justify-between items-center shrink-0 glass z-20">
                    <h2 className="text-xl font-bold text-accent">
                      Referral Details
                    </h2>
                    {/* <span className="text-xs font-mono bg-green-500/20 text-green-400 px-2 py-1 rounded border border-green-500/30">
                      Data Extracted
                    </span> */}
                  </div>

                  <div className="flex-1 overflow-y-auto p-6 pb-24 hide-scroll">
                    <div className="space-y-6 animate-enter">
                      <div className="flex flex-col gap-2">
                        <p className="text-center text-xs font-mono text-muted uppercase tracking-widest">
                          {referralDate.EntryDateTime
                            ? new Date(
                                referralDate.EntryDateTime
                              ).toLocaleString("en-US", {
                                weekday: "long",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })
                            : ""}
                        </p>
                        <div
                          className="w-full p-4 rounded-2xl border text-center flex flex-col items-center justify-center relative overflow-hidden"
                          style={{
                            backgroundColor: "var(--id-bg)",
                            borderColor: "var(--id-border)",
                          }}
                        >
                          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent opacity-50"></div>
                          <p className="text-[10px] uppercase tracking-[0.2em] text-muted mb-1">
                            Referral Generated ID
                          </p>
                          <h1 className="text-4xl font-mono font-bold tracking-widest text-accent drop-shadow-sm">
                            {referralDate.PatientId
                              ? referralDate.PatientId
                              : ""}
                          </h1>
                        </div>
                      </div>

                      <div className="grid grid-cols-4 gap-3">
                        <div className="col-span-3">
                          <label className="input-label">Patient Name</label>
                          <p className="text-base font-medium text-main py-2">
                            {referralDate.PatientName || "-"}
                          </p>
                        </div>
                        <div>
                          <label className="input-label">Age</label>
                          <p className="text-base font-medium text-main py-2">
                            {referralDate.Age || "-"}
                          </p>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="input-label">Gender</label>
                          <p className="text-base font-medium text-main py-2">
                            {referralDate.Gender || "-"}
                          </p>
                        </div>
                        <div>
                          <label className="input-label">Contact #</label>
                          <p className="text-base font-medium text-main py-2">
                            {referralDate.PatientPhoneNumber || "-"}
                          </p>
                        </div>
                      </div>

                      <div>
                        <label className="input-label">Referred To</label>
                        <p className="text-base font-bold text-accent py-2">
                          {referralDate.ReferredToFacilityName || "-"}
                        </p>
                      </div>

                      <div>
                        <label className="input-label">Symptoms & Signs</label>
                        <p className="text-base text-main py-2 whitespace-pre-wrap">
                          {referralDate.SymptomsAndSigns || "-"}
                        </p>
                      </div>

                      <div className="grid grid-cols-3 gap-3">
                        <div className="col-span-2">
                          <label className="input-label">Diagnosis</label>
                          <p className="text-base font-medium text-main py-2">
                            {referralDate.Diagnosis || "-"}
                          </p>
                        </div>
                        <div>
                          <label className="input-label">ICD-10</label>
                          <p className="text-base font-mono font-medium text-main py-2">
                            {referralDate.Icd10Code || "-"}
                          </p>
                        </div>
                      </div>

                      <div>
                        <label className="input-label">
                          Reason for Referral
                        </label>
                        <p className="text-base text-main py-2">
                          {referralDate.ReasonForReferral || "-"}
                        </p>
                      </div>

                      <div>
                        <label className="input-label">
                          Investigations With Results
                        </label>
                        <p className="text-base text-main py-2">
                          {referralDate.InvestigationsWithResults || "-"}
                        </p>
                      </div>

                      <div>
                        <label className="input-label">Treatment Given</label>
                        <p className="text-base text-main py-2">
                          {referralDate.TreatmentGiven || "-"}
                        </p>
                      </div>

                      <div>
                        <label className="input-label">
                          Drug Hypersensitivity
                        </label>
                        <p className="text-base text-main py-2">
                          {referralDate.DrugHypersensitivity || "-"}
                        </p>
                      </div>
                      <div>
                        <label className="input-label">Advice To Patient</label>
                        <p className="text-base text-main py-2">
                          {referralDate.AdviceToPatient || "-"}
                        </p>
                      </div>
                      <div>
                        <label className="input-label">Transport</label>
                        <p className="text-base text-main py-2">
                          {referralDate.Transport || "-"}
                        </p>
                      </div>

                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="input-label">Referrer Name</label>
                          <p className="text-base font-medium text-main py-2">
                            {referralDate.ReferrerName || "-"}
                          </p>
                        </div>
                        <div>
                          <label className="input-label">
                            Referrer Designation
                          </label>
                          <p className="text-base font-medium text-main py-2">
                            {referralDate.ReferrerDesignation || "-"}
                          </p>
                        </div>
                      </div>

                      <div>
                        <label className="input-label">
                          Referrer Organization
                        </label>
                        <p className="text-base text-main py-2">
                          {referralDate.ReferrerOrganization || "-"}
                        </p>
                      </div>
                      <div>
                        <label className="input-label">
                          Referrer Contact #
                        </label>
                        <p className="text-base text-main py-2">
                          {referralDate.ReferrerPhoneNumber || "-"}
                        </p>
                      </div>

                      <div>
                        <label className="input-label">
                          Examination Findings
                        </label>
                        <p className="text-base text-main py-2">
                          {referralDate.ExaminationFindings || "-"}
                        </p>
                      </div>

                      <div>
                        <label className="input-label">Comments</label>
                        <p className="text-base text-main py-2 whitespace-pre-wrap">
                          {referralDate.Comments || "-"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="absolute bottom-0 left-0 right-0 p-4 glass flex gap-4 z-20">
                    <button
                      onClick={closeReferral}
                      className="flex-1 py-3 rounded-xl border border-red-500/30 text-red-400 font-semibold hover:bg-red-500/10 transition-colors"
                    >
                      Close
                    </button>
                    {/* <button
                onClick={submitReferral}
                className="flex-1 py-3 rounded-xl bg-cyan-600 text-white font-bold shadow-lg hover:bg-cyan-500 transition-colors"
              >
                Submit Referral
              </button> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
